module.exports = __webpack_public_path__ + "static/media/group-68.1ae63c85.svg";